import { NgModule } from '@angular/core';
import { ProgressComponent } from './components/progress/progress.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { FilesizePipe } from './pipes/filesize.pipe';
import { TruncNamePipe } from './pipes/trunc-name.pipe';
import { CommonModule } from '@angular/common';
import { HeroComponent } from './components/hero/hero.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { ApplicationService } from './services/application.service';
import { ConstantsService } from './services/constants.service';
import { RouterModule } from '@angular/router';
import { ToggleSwitchComponent } from './components/toggle-switch/toggle-switch.component';
import { KendoLoadingComponent } from './components/kendo-loading/kendo-loading.component';
import { TabsComponent } from './components/tabstrip/tabs/tabs.component';
import { TabComponent } from './components/tabstrip/tab/tab.component';
import { SmartOverflowComponent } from './components/smart-overflow/smart-overflow.component';
import { PidsService } from './services/pids.service';
import { PopupModule } from '@progress/kendo-angular-popup';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
    DropDownListModule,
    DropDownsModule
} from '@progress/kendo-angular-dropdowns';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { IntlModule } from '@progress/kendo-angular-intl';
import { GeneralApiService } from './services/general-api.service';
import { SectionEditButtonComponent } from './components/section-edit-button/section-edit-button.component';
import { QuotientNgCoreModule, SharedModule } from 'quotient-ng-core';
import { HybridEditableSectionComponent } from './components/hybrid-form-section/hybrid-form-section.component';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { DropdownGridFilterComponent } from './components/dropdown-grid-filter/dropdown-grid-filter.component';

@NgModule({
    declarations: [
        ProgressComponent,
        SpinnerComponent,
        FilesizePipe,
        TruncNamePipe,
        HeroComponent,
        BreadcrumbComponent,
        SectionEditButtonComponent,
        ToggleSwitchComponent,
        KendoLoadingComponent,
        TabsComponent,
        TabComponent,
        SmartOverflowComponent,
        HybridEditableSectionComponent,
        DropdownGridFilterComponent
    ],
    exports: [
        ProgressComponent,
        SpinnerComponent,
        FilesizePipe,
        TruncNamePipe,
        HeroComponent,
        BreadcrumbComponent,
        SectionEditButtonComponent,
        ToggleSwitchComponent,
        KendoLoadingComponent,
        TabsComponent,
        TabComponent,
        SmartOverflowComponent,
        HybridEditableSectionComponent,
        DropdownGridFilterComponent
    ],
    providers: [
        ApplicationService,
        ConstantsService,
        PidsService,
        GeneralApiService
    ],
    imports: [
        CommonModule,
        RouterModule,
        PopupModule,
        FormsModule,
        ReactiveFormsModule,
        DropDownsModule,
        DateInputsModule,
        IntlModule,
        QuotientNgCoreModule,
        SharedModule,
        TooltipModule,
        DropDownListModule
    ]
})
export class CoreModule {}
